import { r as registerInstance, c as createEvent, h } from './index-16dc7dde.js';
import './request.constants-deb285e0.js';

const HttpStatusCodes = {
    ACCEPTED: 202,
    BAD_GATEWAY: 502,
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    GATEWAY_TIMEOUT: 504,
    METHOD_NOT_ALLOWED: 405,
    NETWORK_AUTHENTICATION_REQUIRED: 511,
    NOT_FOUND: 404,
    NOT_IMPLEMENTED: 501,
    OK: 200,
    PROCESSING: 102,
    REQUEST_TIMEOUT: 408,
    SERVICE_UNAVAILABLE: 503,
    UNAUTHORIZED: 401,
    TEMPORARY_REDIRECT: 307,
    SERVER_ERROR: 500,
};

const pesDocumentListingCss = ".pes-document-listing{font-size:0.8125rem;line-height:1.5rem;font-weight:300;margin:var(--document-listing-top-margin-mobile, 40px) auto auto}@media screen and (min-width: 980px){.pes-document-listing{margin-top:var(--document-listing-top-margin, 20px)}}";

let PesDocumentListing = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.documentListingReady = createEvent(this, "documentListingReady", 7);
    this.documentFavoriteCountChange = createEvent(this, "documentFavoriteCountChange", 7);
    this.enableDocumentDetailsUrl = false;
    this.applicationSource = 'PES_SE';
    this.view = 'grid';
    this.documentsCardOnly = false;
    this.myFavorites = false;
    this.idmsToken = '';
    this.keyword = '';
    this.onDocumentsReceived = (e) => {
      const { documentcount, statuscode } = e.detail;
      const hasDocuments = documentcount > 0 && statuscode === HttpStatusCodes.OK;
      this.documentListingReady.emit({ hasDocuments, name: this.name });
      window.removeEventListener(e.type, this.onDocumentsReceived);
    };
    this.onAddToDocuments = (event) => {
      this.documentFavoriteCountChange.emit(event.detail.count);
    };
  }
  get fetchSoftwares() {
    return this.software ? 'only' : 'none';
  }
  get configuration() {
    const conf = [
      this.apiEndpoint,
      this.country.toLocaleLowerCase(),
      this.language.toLocaleLowerCase(),
      this.applicationSource,
      `${this.pageType}=${this.resourceId}`,
      `view=${this.view}|fetchSoftwares=${this.fetchSoftwares}`,
      `documentscardonly=${this.documentsCardOnly}`,
    ];
    conf.push(`accessToken=${this.idmsToken}`);
    conf.push(`keyword=${this.keyword}`);
    return conf.join('::');
  }
  render() {
    return (h("div", { class: "pes-document-listing" }, this.software ? (h("document-listing-web-component-software", { ref: () => {
        window.addEventListener('documentsReceivedSoftware', this.onDocumentsReceived);
        window.addEventListener('myDocumentsCountUpdateSoftware', this.onAddToDocuments);
      }, configuration: this.configuration, myfavorites: this.myFavorites ? 'true' : 'false' })) : (h("document-listing-web-component", { ref: () => {
        window.addEventListener('documentsReceived', this.onDocumentsReceived);
        window.addEventListener('myDocumentsCountUpdate', this.onAddToDocuments);
      }, configuration: this.configuration, myfavorites: this.myFavorites ? 'true' : 'false' }))));
  }
};
PesDocumentListing.style = pesDocumentListingCss;

export { PesDocumentListing as pes_document_listing };
